import script from "./DFFLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./DFFLoading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__